import { teaserMessages as messages } from '../../../../../../customization-messages';

export const TeaserSchema = ({ data, intl }) => {
  // O primeiro valor representa o percentual da largura da imagem
  // a ser aplicado à altura
  const aspectRatioChoices = [
    ['100%', '1/1'],
    ['66.6666%', '3/2'],
    ['75%', '4/3'],
    ['56.25%', '16/9'],
    ['50%', '2/1'],
    ['33.3333%', '3/1'],
    ['125%', '4/5'],
    ['120%', '5/6'],
    ['150%', '3/4'],
    ['177.78%', '9/16'],
  ];

  const schema = {
    title: intl.formatMessage(messages.teaser),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.Default),
        fields: [
          'href',
          'overwrite',
          ...(data?.overwrite
            ? ['subtitle', 'title', 'description', 'preview_image', 'image_alt']
            : []),
        ],
      },
      {
        id: 'image',
        title: intl.formatMessage(messages.Image),
        fields: [
          'aspectRatioDesktop',
          'aspectRatioMobile',
          'horizontalAlign',
          'verticalAlign',
          //'imageBackground',
        ],
      },
      {
        id: 'fields',
        title: intl.formatMessage(messages.Fields),
        fields: ['hideImage', 'hideDescription', 'hideSubtitle'],
      },
    ],

    properties: {
      href: {
        title: intl.formatMessage(messages.Target),
        description: intl.formatMessage(messages.hrefDescription),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: [
          'Title',
          'head_title',
          'Description',
          'Category',
          'dados_noticia',
          'Subtitle',
          'hasPreviewImage',
          'image_field',
          'image_scales',
          '@type',
          'review_state',
        ],
        allowExternals: true,
      },
      overwrite: {
        title: intl.formatMessage(messages.overwrite),
        description: intl.formatMessage(messages.overwriteDescription),
        type: 'boolean',
        default: false,
      },
      title: {
        title: intl.formatMessage(messages.title),
      },
      subtitle: {
        title: intl.formatMessage(messages.subtitle),
      },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      preview_image: {
        title: intl.formatMessage(messages.imageOverride),
        widget: 'object_browser',
        mode: 'image',
        allowExternals: true,
        selectedItemAttrs: ['image_field', 'image_scales'],
      },
      image_alt: {
        title: intl.formatMessage(messages.imageAlt),
        description: intl.formatMessage(messages.imageAltDescription),
      },
      openLinkInNewTab: {
        title: intl.formatMessage(messages.openLinkInNewTab),
        type: 'boolean',
      },
      aspectRatioDesktop: {
        title: intl.formatMessage(messages.aspectRatioDesktop),
        required: true,
        noValueOption: true,
        default: '56.25%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
      aspectRatioMobile: {
        title: intl.formatMessage(messages.aspectRatioMobile),
        required: true,
        noValueOption: true,
        default: '66.6666%',
        type: 'string',
        factory: 'Choice',
        choices: aspectRatioChoices,
      },
      // imageBackground: {
      //   title: intl.formatMessage(messages.imageAsBackground),
      //   description: intl.formatMessage(messages.imageAsBackgroundDescription),
      //   type: 'boolean',
      //   default: false,
      //   isDisabled: data?.hideImage,
      // },
      horizontalAlign: {
        title: intl.formatMessage(messages.horizontalAlign),
        type: 'string',
        widget: 'position_widget',
      },
      verticalAlign: {
        title: intl.formatMessage(messages.verticalAlign),
        type: 'string',
        widget: 'position_widget',
        direction: 'vertical',
      },
      hideImage: {
        title: intl.formatMessage(messages.hideImage),
        type: 'boolean',
        default: false,
        isDisabled: data?.imageBackground,
      },
      hideSubtitle: {
        title: intl.formatMessage(messages.hideSubtitleCategory),
        type: 'boolean',
        default: false,
      },
      hideDescription: {
        title: intl.formatMessage(messages.hideDescription),
        type: 'boolean',
        default: false,
      },
    },
    required: ['href'],
  };

  return schema;
};

export const gridTeaserDisableStylingSchema = ({ schema, formData, intl }) => {
  schema.fieldsets = schema.fieldsets.filter((item) => item.id !== 'styling');
  return schema;
};
